import { Controller } from '@hotwired/stimulus';
import { createPopper } from '@popperjs/core';
import {getWindowWidth} from "../helpers";

export default class extends Controller {
  connect() {
    this.timeTableCellsLogin = this.element.querySelectorAll('[data-popover-login]');
    this.timeTableCellsCancel = this.element.querySelectorAll('[data-popover-cancel]');
    this.timeTableCellsBanned = this.element.querySelectorAll('[data-popover-banned]');

    this.loginPopover = this.element.querySelector('#loginPopover');
    this.cancelPopover = this.element.querySelector('#cancelPopover');
    this.bannedPopover = this.element.querySelector('#bannedPopover');

    this.loginModal = this.element.querySelector('#loginModal');
    this.cancelModal = this.element.querySelector('#cancelModal');
    this.bannedModal = this.element.querySelector('#bannedModal');

    if (getWindowWidth() > 768) {
      if (this.loginPopover) {
        this.addPopovers(this.timeTableCellsLogin, this.loginPopover);
      }

      if (this.cancelPopover) {
        this.addPopovers(this.timeTableCellsCancel, this.cancelPopover);
      }

      if (this.bannedPopover) {
        this.addPopovers(this.timeTableCellsBanned, this.bannedPopover);
      }
    } else {
      if (this.loginModal) {
        this.addModals(this.timeTableCellsLogin, this.loginModal);
      }

      if (this.cancelModal) {
        this.addModals(this.timeTableCellsCancel, this.cancelModal);
      }

      if (this.bannedModal) {
        this.addModals(this.timeTableCellsBanned, this.bannedModal);
      }
    }
  }

  changeCoach() {
    this.updateVisibleCells();
  }

  updateVisibleCells() {
    const activeTab = this.element.querySelector('.schedules__categories--single.is-active');
    const coachSelect = this.element.querySelector('.coach-select');

    if (activeTab) {
      let places = null;

      try {
        places = activeTab.dataset.places ? JSON.parse(activeTab.dataset.places) : null;
      } catch {
      }

      if (places) {
        for (const cell of this.element.querySelectorAll('.timetable-cell')) {
          let active = false;
          let activeCoach = true;

          if (coachSelect) {
            activeCoach = coachSelect.value === '0' || coachSelect.value === cell.dataset.coach;
          }

          for (const place of places) {
            if (cell.dataset.places.indexOf(place) >= 0) {
              active = true;
              break;
            }
          }

          if (active && activeCoach) {
            cell.classList.remove('d-none');
          } else {
            cell.classList.add('d-none');
          }
        }

        for (const row of this.element.querySelectorAll('.timetable-cell__row')) {
          if (row.querySelector('.timetable-cell:not(.d-none)')) {
            row.classList.remove('d-none');
          } else {
            row.classList.add('d-none');
          }
        }
      }
    }
  }

  changeSelect(event) {
    const mainTabs = this.element.querySelectorAll('.schedules__categories--single');

    for (const tabInner of mainTabs) {
      tabInner.classList.remove('is-active');
      tabInner.style.background = '#ffffff';
    }

    const targetTab = mainTabs[event.currentTarget.selectedIndex];
    const styles = targetTab.dataset.styles ? JSON.parse(targetTab.dataset.styles) : null;

    targetTab.classList.add('is-active');
    this.updateVisibleCells();

    if (!styles) {
      return;
    }

    targetTab.style.background = styles.color;
  }

  toggleTab(event) {
    const tab = event.currentTarget;
    const styles = tab.dataset.styles ? JSON.parse(tab.dataset.styles) : null;
    const places = tab.dataset.places ? JSON.parse(tab.dataset.places) : null;

    if (!styles || !places) {
      return;
    }

    for (const tabInner of this.element.querySelectorAll('.schedules__categories--single')) {
      tabInner.classList.remove('is-active');
      tabInner.style.background = '#ffffff';
    }

    tab.classList.add('is-active');
    tab.style.background = styles.color;

    this.updateVisibleCells();
  }

  addPopovers(elements, popover) {
    elements.forEach((el) => {
      el.addEventListener('mouseenter', () => {
        createPopper(el, popover, {
          placement: 'right',
        });
        popover.style.display = 'block';

        if (el.hasAttribute('data-popover-cancel')) {
          popover.querySelector('input[name="reservation_code"]').setAttribute('value', el.getAttribute('reservation-code'));
        }
      });

      el.addEventListener('mouseleave', () => {
        popover.style.display = 'none';
      });

      popover.addEventListener('mouseenter', () => {
        popover.style.display = 'block';
      });

      popover.addEventListener('mouseleave', () => {
        popover.style.display = 'none';
      });

    });

  }

  addModals(elements, modal) {
    elements.forEach((el) => {
      const button = el.querySelectorAll('button')[0];
      button.disabled = false;

      button.addEventListener('click', () => {
        const modalController = Stimulus.getControllerForElementAndIdentifier(modal, 'modal');
        console.log('moidal click')

        if (modalController) {
          if (el.hasAttribute('data-popover-cancel')) {
            modal.querySelector('input[name="reservation_code"]').setAttribute('value', el.getAttribute('reservation-code'));
          }
          modalController.showModal();
        }
      })
    })
  }
}
